
export const getLocalStorageValue = (key: string): string | false => {
    const encKey = btoa(key);
    const data = localStorage.getItem(encKey);
    if (!data) {
        return false;
    }
    return decodeURIComponent(escape(atob(data)));
};

export const setLocalStorageValue = (key: string, value: string): void => {
    const encKey = btoa(key);
    const encValue = btoa(unescape(encodeURIComponent(value)));
    localStorage.setItem(encKey, encValue);
};

export const removeLocalStorageValue = (key: string): void => {
    localStorage.removeItem(btoa(key));
};

export interface StoredUserEntity {
    _id?: string;
    isDoctor?: boolean;
    firstName?: string;
    lastName?: string;
    [key: string]: unknown;
}
